import type { Landlord, Action } from '@root/types';

export type LandlordsStoreState = {
  byId: Record<string, Landlord | undefined>;
};

const defaultState = {
  byId: {},
};

export default function landlordsReducer(
  state: LandlordsStoreState = defaultState,
  action: Action,
) {
  switch (action.type) {
    case 'LANDLORD_PAGE_LOADED':
    case 'LANDLORD_PAGE_SERVER_SIDE_RENDER_INITIAL_LOAD': {
      const { data } = action.payload;

      return { ...state, byId: { ...state.byId, [data.slug]: data } };
    }
    default:
      return state;
  }
}
